export default __webpack_public_path__ + "static/media/maxWinFsIcon.75711adc.svg";